<!--通用表格组件，具有分页功能-->
<template>
  <div class="ps-table">
    <el-table
      :data="page.data"
      class="tableDiv"
      style="width: 100%"
      :row-style="rowColor"
      @selection-change="changeSelect"
      @cell-click="handlerCellClick"
    >
      <slot name="firstColumn"></slot>
      <el-table-column
        v-for="(value,key) in page.headers"
        :key="key"
        :prop="key"
        :label="value"
        :fixed="fixedColumns?fixedRoles(value):false"
        :show-overflow-tooltip="true"
        align="center"
      ></el-table-column>
      <slot></slot>
    </el-table>
    <el-pagination
      :current-Page="page.pageIndex"
      v-if="pageFalse"
      :page-size="page.pageSize"
      :total="page.total"
      layout="total,sizes,prev,pager,next,jumper"
      :page-sizes="pageSizes"
      @size-change="sizeChange"
      @current-change="pageIndexChange"
    ></el-pagination>
  </div>
</template>

<script>
export default {
  name: 'ad-table',
  props: {
    page: {
      type: Object,
      default: function () {
        return {
          headers: [],
          data: [],
          pageSize: 10,
          pageIndex: 0
        };
      },
      required: true
    },
    pageFalse: {
      type: Boolean,
      required: true,
      default: false
    },
    headerHeight: {
      type: String,
      default: '30px',
      required: false
    },
    fixedColumns: {
      type: Array,
      required: false
    }
  },
  data () {
    return {
      pageSizes: [10, 20, 50],
      timer: '',
      options: {
        target: '',
        text: ''
      }
    };
  },
  methods: {
    fixedRoles (header) {
      return this.fixedColumns.indexOf(header.field) ? this.fixedColumns : false;
    },
    sizeChange (pageSize) {
      this.page.pageSize = pageSize;
      this.$emit('sendPageSize', {
        pageSize,
        pageIndex: this.page.pageIndex
      });
    },
    pageIndexChange (pageIndex) {
      this.page.pageIndex = pageIndex;
      this.$emit('sendPageSize', {
        pageSize: this.page.pageSize,
        pageIndex
      });
    },
    rowColor (row, index) {
      if (index % 2 === 0) {
        return { 'background-color': '#f9f9f9' };
      }
    },
    handlerCellClick (row, column, cell, event) {
      this.$emit('handleCellClick', {
        row,
        column,
        cell,
        event
      });
    },
    changeSelect (row) {
      this.$emit('selectChange', row);
    }
  }
};
</script>

<style lang="scss" rel="stylesheet/scss">
.ps-table {
  position: relative;
  width: 100%;

  // .el-table {
  //   border-radius: 3px;
  //   border: none;
  //   border-color: transparent;
  //   th {
  //     background: #fff;
  //   }
  // }
  // .el-table__header-wrapper {
  //   thead {
  //     /*font-size: 18px;*/
  //     div {
  //       color: #566874;
  //     }
  //   }
  // }
  // .el-table__body-wrapper {
  //   tbody {
  //     font-size: 14px;
  //     td {
  //       div {
  //         color: #0f1a23;
  //         white-space: nowrap;
  //         cursor: pointer;
  //       }
  //     }
  //   }
  // }
  // .el-table td,
  // .el-table th.is-leaf {
  //   border-bottom-color: transparent;
  // }
  // .el-table__footer-wrapper thead div,
  // .el-table__header-wrapper thead div {
  //   background: #fff;
  // }
  // .el-pagination {
  //   padding: 20px 5px;
  // }
  // .el-pager li.active {
  //   background: #1d2b36;
  //   border-color: #1d2b36;
  //   color: #fff;
  // }
  // .el-table td,
  // .el-table th.is-leaf {
  //   border: none;
  // }
  // .el-table::after,
  // .el-table::before {
  //   content: "";
  //   position: absolute;
  //   background-color: transparent;
  //   z-index: 1;
  // }
  // .el-pagination__editor:focus {
  //   outline: 0;
  //   border-color: #1d2b36;
  // }
  // .el-pager li:hover {
  //   color: #1d2b36;
  // }
}
</style>
